<template>
  <div class="km-module">
    <div
      id="kmAuthModal"
      ref="modalEl"
      class="modal auth-modal"
      :class="{ fade: layout !== 'C' }"
      tabindex="-1"
      aria-labelledby="kmAuthModal"
      aria-hidden="true"
      data-bs-focus="false"
      aria-modal="true"
      data-bs-backdrop="false"
      @click.self="hide"
    >
      <div
        class="modal-dialog"
        :class="{
          'modal-dialog-centered': layout === 'A',
          'modal-fullscreen': ['B', 'C'].includes(layout)
        }"
      >
        <div class="modal-content border-0 bg-transparent">
          <div
            v-if="layout === 'A'"
            class="modal-header py-2 px-0 border-0 bg-transparent"
          >
            <button
              type="button"
              class="ms-auto"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <Icon
                :default-src="closeDefaultSrc"
                :hover-src="closeHoverSrc"
                alt="close"
              />
            </button>
          </div>
          <div class="modal-body p-0">
            <button
              v-if="layout === 'B'"
              type="button"
              class="position-absolute end-0 top-0 mt-2 me-3"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <Icon
                :default-src="fullCloseDefaultSrc"
                :hover-src="fullCloseHoverSrc"
                alt="close"
              />
            </button>
            <!--layout A-->
            <!--signup - step: pc(horizontal), mobile(vertical) / no step: vertical-->
            <section
              v-if="layout === 'A'"
              class="auth-modal-container"
              :class="[
                step ? (!isMobile ? 'horizontal' : 'vertical') : 'vertical'
              ]"
            >
              <div
                v-if="!!imgSrc"
                class="auth-img"
                :style="{
                  backgroundImage: `url(${imgSrc})`
                }"
              ></div>
              <div
                class="py-5 auth-content"
                :class="{ 'pt-4': !isMobile && !!imgSrc && !step }"
              >
                <div
                  v-if="menu === 'button' && category === 'forgetPwd'"
                  class="px-4"
                >
                  <h3 class="mb-4 text-center">
                    {{ $t('component.ForgotPasswordModal.header') }}
                  </h3>
                  <div class="mb-4 d-grid gap-4">
                    <template v-for="forgetPwdButton in forgetPwdButtons">
                      <button
                        v-if="forgetPwdButton.enable"
                        :key="forgetPwdButton.category"
                        class="btn btn-outline-gray"
                        type="button"
                        @click.prevent="forgetPwdButton.method()"
                      >
                        {{ forgetPwdButton.title }}
                      </button>
                    </template>
                  </div>
                  <!--login-->
                  <div class="text-center">
                    <span class="me-2">{{
                      $t('component.ForgotPasswordModal.login')
                    }}</span>
                    <a
                      href="#"
                      class="text-decoration-underline auth-form-link"
                      @click.prevent="switchCategory('login')"
                    >
                      {{ $t('component.AuthModal.list.login') }}</a
                    >
                  </div>
                </div>
                <template v-else>
                  <nav
                    v-if="menu === 'tabs'"
                    class="mb-5 px-3 nav nav-justified"
                  >
                    <a
                      v-for="tab in tabs"
                      :key="tab.category"
                      class="nav-link"
                      href="#"
                      :class="{
                        active: category === tab.category,
                        'd-none': !tab.enable
                      }"
                      @click.prevent="switchCategory(tab.category)"
                    >
                      {{ tab.title }}</a
                    >
                  </nav>
                  <h3
                    v-if="menu === 'button'"
                    class="px-lg-4 px-3 mb-4 text-center"
                  >
                    {{ title }}
                  </h3>
                  <div class="px-lg-4 px-3">
                    <LoginForm
                      v-if="category === 'login'"
                      :layout="layout"
                      :menu="menu"
                      :custom-btn-primary-class="customBtnPrimaryClass"
                      @switchCategory="switchCategory"
                      @loginSuccessAfter="$emit('loginSuccessAfter')"
                    />
                    <SignUpForm
                      v-if="!step && category === 'signUp'"
                      :layout="layout"
                      :menu="menu"
                      :intel-countries="intelCountries"
                      :custom-form-check-input-class="customFormCheckInputClass"
                      :custom-btn-primary-class="customBtnPrimaryClass"
                      v-bind="
                        customUsernameRule
                          ? {
                              customUsernameRule
                            }
                          : {}
                      "
                      @switchCategory="switchCategory"
                      @signUpSuccessAfter="$emit('signUpSuccessAfter')"
                    />
                    <SignUpStepForm
                      v-if="step && category === 'signUp'"
                      :layout="layout"
                      :menu="menu"
                      :intel-countries="intelCountries"
                      :has-confirm-password="hasSignUpConfirmPassword"
                      :has-actual-name="hasSignUpActualName"
                      :has-email-verify-code="hasEmailVerifyCode"
                      :custom-form-check-input-class="customFormCheckInputClass"
                      :custom-btn-primary-class="customBtnPrimaryClass"
                      :custom-btn-outline-primary-class="
                        customBtnOutlinePrimaryClass
                      "
                      v-bind="
                        customUsernameRule
                          ? {
                              customUsernameRule
                            }
                          : {}
                      "
                      @switchCategory="switchCategory"
                      @signUpSuccessAfter="$emit('signUpSuccessAfter')"
                    />
                    <ForgetPwdEmailForm
                      v-if="category === 'forgetPwdEmail'"
                      :layout="layout"
                      :menu="menu"
                      :buttons="forgetPwdButtons"
                      :custom-btn-primary-class="customBtnPrimaryClass"
                      @switchCategory="switchCategory"
                    />
                    <ForgetPwdTelForm
                      v-if="category === 'forgetPwdTel'"
                      :layout="layout"
                      :menu="menu"
                      :intel-countries="intelCountries"
                      :buttons="forgetPwdButtons"
                      :custom-btn-primary-class="customBtnPrimaryClass"
                      @switchCategory="switchCategory"
                    />
                  </div>
                </template>
              </div>
            </section>
            <!--layout B, C-->
            <section
              v-if="['B', 'C'].includes(layout)"
              class="auth-modal-container"
            >
              <div
                v-if="!!imgSrc"
                class="auth-img"
                :style="{
                  backgroundImage: `url(${imgSrc})`
                }"
              ></div>
              <div class="auth-content px-3">
                <div class="auth-content-form">
                  <template
                    v-if="menu === 'button' && category === 'forgetPwd'"
                  >
                    <div
                      class="mb-5 auth-logo"
                      :style="{ backgroundImage: `url(${logoSrc})` }"
                    ></div>
                    <h3 class="mb-3 text-center">
                      {{ $t('component.ForgotPasswordModal.header') }}
                    </h3>
                    <div class="mb-4 text-center">
                      <span class="me-2">{{
                        $t('component.ForgotPasswordModal.login')
                      }}</span>
                      <a
                        href="#"
                        class="text-decoration-underline auth-form-link"
                        @click.prevent="switchCategory('login')"
                      >
                        {{ $t('component.AuthModal.list.login') }}</a
                      >
                    </div>
                    <div class="d-grid gap-4">
                      <template v-for="forgetPwdButton in forgetPwdButtons">
                        <button
                          v-if="forgetPwdButton.enable"
                          :key="forgetPwdButton.category"
                          class="btn btn-outline-gray"
                          type="button"
                          @click.prevent="forgetPwdButton.method()"
                        >
                          {{ forgetPwdButton.title }}
                        </button>
                      </template>
                    </div>
                  </template>
                  <template v-else>
                    <template v-if="menu === 'tabs'">
                      <div
                        class="mb-4 auth-logo"
                        :style="{ backgroundImage: `url(${logoSrc})` }"
                      ></div>
                      <nav class="mb-4 w-100 nav nav-justified">
                        <a
                          v-for="tab in tabs"
                          :key="tab.category"
                          class="nav-link"
                          href="#"
                          :class="{
                            active: category === tab.category,
                            'd-none': !tab.enable
                          }"
                          @click.prevent="switchCategory(tab.category)"
                        >
                          {{ tab.title }}</a
                        >
                      </nav>
                    </template>
                    <template v-if="menu === 'button'">
                      <div
                        class="mb-5 auth-logo"
                        :style="{ backgroundImage: `url(${logoSrc})` }"
                      ></div>
                      <h3 class="mb-3 w-100 text-center">
                        {{ title }}
                      </h3>
                    </template>
                    <LoginForm
                      v-if="category === 'login'"
                      :layout="layout"
                      :menu="menu"
                      :custom-btn-primary-class="customBtnPrimaryClass"
                      @switchCategory="switchCategory"
                      @loginSuccessAfter="$emit('loginSuccessAfter')"
                    />
                    <SignUpForm
                      v-if="!step && category === 'signUp'"
                      :layout="layout"
                      :menu="menu"
                      :intel-countries="intelCountries"
                      :custom-form-check-input-class="customFormCheckInputClass"
                      :custom-btn-primary-class="customBtnPrimaryClass"
                      v-bind="
                        customUsernameRule
                          ? {
                              customUsernameRule
                            }
                          : {}
                      "
                      @switchCategory="switchCategory"
                      @signUpSuccessAfter="$emit('signUpSuccessAfter')"
                    />
                    <SignUpStepForm
                      v-if="step && category === 'signUp'"
                      :layout="layout"
                      :menu="menu"
                      :intel-countries="intelCountries"
                      :has-confirm-password="hasSignUpConfirmPassword"
                      :has-actual-name="hasSignUpActualName"
                      :has-email-verify-code="hasEmailVerifyCode"
                      :custom-form-check-input-class="customFormCheckInputClass"
                      :custom-btn-primary-class="customBtnPrimaryClass"
                      :custom-btn-outline-primary-class="
                        customBtnOutlinePrimaryClass
                      "
                      v-bind="
                        customUsernameRule
                          ? {
                              customUsernameRule
                            }
                          : {}
                      "
                      @switchCategory="switchCategory"
                      @signUpSuccessAfter="$emit('signUpSuccessAfter')"
                    />
                    <ForgetPwdEmailForm
                      v-if="category === 'forgetPwdEmail'"
                      :layout="layout"
                      :menu="menu"
                      :buttons="forgetPwdButtons"
                      :custom-btn-primary-class="customBtnPrimaryClass"
                      @switchCategory="switchCategory"
                    />
                    <ForgetPwdTelForm
                      v-if="category === 'forgetPwdTel'"
                      :layout="layout"
                      :menu="menu"
                      :intel-countries="intelCountries"
                      :buttons="forgetPwdButtons"
                      :custom-btn-primary-class="customBtnPrimaryClass"
                      @switchCategory="switchCategory"
                    />
                  </template>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  useStore
} from '@nuxtjs/composition-api'
import Icon from './Icon.vue'
import LoginForm from './LoginForm.vue'
import SignUpStepForm from './SignUpStepForm.vue'
import SignUpForm from './SignUpForm.vue'
import ForgetPwdTelForm from './ForgetPwdTelForm.vue'
import ForgetPwdEmailForm from './ForgetPwdEmailForm.vue'

export default defineComponent({
  components: {
    Icon,
    LoginForm,
    SignUpStepForm,
    SignUpForm,
    ForgetPwdTelForm,
    ForgetPwdEmailForm
  },
  props: {
    layout: {
      type: String,
      default: 'A' // A : block modal | B: full modal | C: full modal no close
    },
    menu: {
      type: String,
      default: 'tabs' // tabs | button
    },
    step: {
      type: Boolean,
      default: false // signUp 3 step or one step
    },
    hasImg: {
      type: Boolean,
      default: true
    },
    imgPcSrc: {
      type: String,
      default: null
    },
    imgMobileSrc: {
      type: String,
      default: null
    },
    logoSrc: {
      type: String,
      default: 'https://ik.imagekit.io/1pzxddx3qqv/common/img/logo.png'
    },
    closeDefaultSrc: {
      type: String,
      default:
        'https://ik.imagekit.io/1pzxddx3qqv/common/img/popup_close_btn_default.png'
    },
    closeHoverSrc: {
      type: String,
      default:
        'https://ik.imagekit.io/1pzxddx3qqv/common/img/popup_close_btn_hover.png'
    },
    fullCloseDefaultSrc: {
      type: String,
      default:
        'https://ik.imagekit.io/1pzxddx3qqv/common/img/fullscreen-close-btn-default.png'
    },
    fullCloseHoverSrc: {
      type: String,
      default:
        'https://ik.imagekit.io/1pzxddx3qqv/common/img/fullscreen-close-btn-hover.png'
    },
    intelCountries: {
      type: Array,
      default: () => []
    },
    hasForgetPwdTelForm: {
      type: Boolean,
      default: true
    },
    hasSignUpConfirmPassword: {
      type: Boolean,
      default: false
    },
    hasSignUpActualName: {
      type: Boolean,
      default: false
    },
    hasEmailVerifyCode: {
      type: Boolean,
      default: true
    },
    customUsernameRule: {
      type: [String, Object],
      default: null
    },
    // custom class
    // signup / signup step
    customFormCheckInputClass: {
      type: String,
      default: 'form-check-input'
    },
    // login / signup / signup step / forget tel / forget email
    customBtnPrimaryClass: {
      type: String,
      default: 'btn-primary'
    },
    // signup step
    customBtnOutlinePrimaryClass: {
      type: String,
      default: 'btn-outline-primary'
    }
  },
  setup(props, context) {
    const store = useStore()

    const modal = ref({})
    const modalEl = ref(null)

    const category = ref(null) // null: close modal
    const tabGroup = computed(() => ({
      auth: [
        {
          category: 'login',
          title: context.root.$t('component.AuthModal.list.login'),
          enable: props.layout !== 'C' // C 固定只顯示signUp類別
        },
        {
          category: 'signUp',
          title: context.root.$t('component.AuthModal.list.signUp'),
          enable: true
        }
      ],
      forgetPwd: [
        {
          category: 'forgetPwdEmail',
          title: context.root.$t(
            'component.ForgotPasswordModal.category.email'
          ),
          enable: true
        },
        {
          category: 'forgetPwdTel',
          title: context.root.$t('component.ForgotPasswordModal.category.sms'),
          enable: props.hasForgetPwdTelForm
        }
      ]
    }))

    const tabs = computed(() => {
      return (
        Object.values(tabGroup.value).find(tabs =>
          tabs.find(tab => tab.category === category.value)
        ) || []
      )
    })
    const title = computed(() => {
      return tabs.value.find(tab => tab.category === category.value)?.title
    })
    const forgetPwdButtons = computed(() => {
      return [
        ...tabGroup.value.forgetPwd.map(tab => ({
          ...tab,
          enable:
            tab.enable &&
            (category.value === 'forgetPwd' ||
              (props.menu === 'button' && tab.category !== category.value)),
          method: () => switchCategory(tab.category)
        })),
        {
          category: 'forgetPwdCSR',
          title: 'Online support',
          enable: true,
          method: () => context.emit('openCSRWidget')
        }
      ]
    })
    const imgSrc = computed(() => {
      if (!props.hasImg) {
        return null
      }
      if (props.layout === 'A' && !isMobile.value) {
        return props.step ? props.imgPcSrc : props.imgMobileSrc
      }
      if (['B', 'C'].includes(props.layout)) {
        return !isMobile.value ? props.imgPcSrc : props.imgMobileSrc
      }
      return null
    })
    const isMobile = computed(() => store.state.isMobile)

    onMounted(() => {
      nextTick(() => {
        const Modal = require('bootstrap').Modal
        modal.value = new Modal(modalEl.value)

        modalEl.value.addEventListener('hidden.bs.modal', closed)
      })
    })

    onBeforeUnmount(() => {
      hide()
    })

    function closed() {
      category.value = null
    }

    function show(form) {
      category.value = form

      nextTick(() => {
        modal.value.show()
      })
    }

    function hide() {
      modal.value.hide()
    }

    function switchCategory(form) {
      if (!form) {
        if (props.layout !== 'C') {
          hide()
        }
        return
      }

      category.value = form

      if (form === 'forgetPwd' && props.menu === 'tabs') {
        category.value = tabGroup.value.forgetPwd[0].category
      }
    }

    return {
      modalEl,
      isMobile,
      category,
      tabGroup,
      tabs,
      title,
      forgetPwdButtons,
      imgSrc,

      show,
      hide,
      switchCategory
    }
  }
})
</script>
